export default function TagVisual({ size = 240, imageClassName = '' }) {
  return (
    <div className="flex items-center justify-center" style={{ width: size, maxWidth: '100%' }}>
      <img
        src="/connect-tag.png?v=20261019-2"
        alt="Connect Near Me tag"
        className={`block h-auto w-full object-contain ${imageClassName}`}
      />
    </div>
  );
}
